import React, { useState } from "react";
import "./styles.css";
import { ClickAwayListener } from "@mui/material";
//external or internal compoents
import SearchBox from "../../components/SearchBox";
import FilterBox from "../../components/FilterBox";
import FilterContainer from "../../components/FilterContainer";
import FilterBoxGoals from "../../components/FilterBoxGoals";
import FilterBoxPerformancePlan from "../../components/FilterBoxPerformancePlan";
import FilterBoxLicenceAnalytics from "../../components/FilterBoxLicenceAnaltyics";
import HomeFilterPanel from "../../components/FilterBox/HomeFilterPanel";
import ActiveFilterChips from "../../components/FilterBox/ActiveFilterChips";

const SearchFilterContainer = (props: any) => {
  const { parent, othersOptions } = props;
  const [filterOpen, setFilterOpen] = useState(false);

  return (
    <React.Fragment>
      <div className={"SearchFilterRoot"}>
        {/* ClickAwayListener wraps the button + floating panel so clicks
            inside the panel don't trigger a close */}
        {parent === "home" ? (
          <ClickAwayListener onClickAway={() => setFilterOpen(false)}>
            <div className={"SearchFilterAnchor"}>
              <div className={"SearchFilterWrapper"}>
                {parent !== "licenceAnalytics" && (
                  <SearchBox
                    searchBoxStyle={"searchBoxMain"}
                    parent={parent}
                  />
                )}
                <FilterBox
                  isOpen={filterOpen}
                  onToggle={() => setFilterOpen((v) => !v)}
                />
              </div>
              {/* Floating panel — absolutely positioned, takes no layout space */}
              <HomeFilterPanel
                isOpen={filterOpen}
                onClose={() => setFilterOpen(false)}
              />
            </div>
          </ClickAwayListener>
        ) : (
          <div className={"SearchFilterWrapper"}>
            {parent !== "licenceAnalytics" && (
              <SearchBox
                searchBoxStyle={"searchBoxMain"}
                parent={parent ? parent : ""}
              />
            )}
            {parent == "Goals & Strategy" && <FilterBoxGoals />}
            {parent == "Performance Plan" && <FilterBoxPerformancePlan />}
            {parent == "evaluationDashboard" && (
              <FilterContainer othersOptions={othersOptions} />
            )}
            {parent == "licenceAnalytics" && <FilterBoxLicenceAnalytics />}
          </div>
        )}
        {/* Chips sit below in document flow — only shown when panel is closed */}
        {parent === "home" && !filterOpen && <ActiveFilterChips />}
      </div>
    </React.Fragment>
  );
};

export default SearchFilterContainer;
